"use client"

import {useEffect, useState} from 'react';
import {useAppStore} from "@/store/AppStore";
import {UserInfo} from "@/types/User";

const useUserInfo = () => {
  const [data, setData] = useState<UserInfo | undefined>(undefined);
  const user = useAppStore((state) => state.user);
  const appStore = useAppStore();
  const userInfo = appStore.userInfo;
  const loggedInChecking = useAppStore((state) => state.loggedInChecking);
  const loadUserInfo = useAppStore((state) => state.loadUserInfo);
  const setUserInfo = useAppStore((state) => state.setUserInfo);

  useEffect(() => {
    const fetchData = async () => {
      if (loggedInChecking) {
        return false
      }
      if (!user?.access_token) {
        console.error('No access token');
        console.error(user);
        //setRefresh(true);
        return false
      }
      const fetched = await loadUserInfo(user?.access_token)
      if (fetched) {
        setData(fetched);
        setUserInfo(fetched);
      }
    }
    if (!data || !userInfo) {
      fetchData();
    }
  }, [loggedInChecking, data, loadUserInfo, user, userInfo, setUserInfo]);

  return data;
};

export default useUserInfo;
